module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"paymentMethod":"Способ оплаты","change":"Изменить","addNewCard":"Добавить карту","failed":"Не удалось выполнить списание с карты {failedAt}"}}')
  delete Component.options._Ctor
}
